import { n as e, t } from "./context-BrD4AniQ.js";
import { i as n, n as r, r as i, t as a } from "./constants-DOpa8YMW.js";
import { n as o } from "./esm-Be30MpcN.js";
import * as s from "react";
import { Suspense as c, lazy as l, useEffect as u, useMemo as d, useRef as f, useState as p } from "react";
import { jsx as m } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var h = Object.defineProperty, g = (e, t) => {
	let n = {};
	for (var r in e) h(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || h(n, Symbol.toStringTag, { value: "Module" }), n;
}, _ = "w-full h-full relative overflow-hidden", v = l(() => import("./Maptiler-Cy2r6w4G.js")), y = l(() => import("./Google-D1kMMDIv.js")), b = l(() => import("./Mapbox-CIislOVu.js")), x = l(() => import("./Testing-BNJwzbRK.js")), S = ({ children: t }) => {
	let { mapProvider: n, center: a, zoom: o = i.zoom, pitch: s = i.pitch, bearing: l = i.bearing, cooperativeGestures: u = i.cooperativeGestures, zoomPosition: f } = e(), [h] = p(o), g = d(() => {
		switch (n?.name) {
			case "maptiler": return v;
			case "google": return y;
			case "mapbox": return b;
			case "testing": return x;
			default: return x;
		}
	}, [n]);
	return /* @__PURE__ */ m("div", {
		className: _,
		"data-testid": "base-map",
		"data-map-provider-name": n?.name,
		"data-map-provider-theme": n?.theme || r[n?.name] || r.maptiler,
		"data-initial-zoom": h,
		"data-pitch": s,
		"data-bearing": l,
		"data-cooperative-gestures": u,
		"data-zoom-position": f,
		"data-center-latitude": a.latitude,
		"data-center-longitude": a.longitude,
		children: /* @__PURE__ */ m(c, {
			fallback: null,
			children: /* @__PURE__ */ m(g, { children: t })
		})
	});
}, C = l(() => import("./Maptiler-DJScKW8p.js")), w = l(() => import("./Google-CH7a2yx-.js")), T = l(() => import("./Mapbox-DtZmt1D_.js")), ee = l(() => import("./Testing-DzWAcbhL.js"));
function E(t) {
	let { mapProvider: n, setCenterPinMarkerPoints: r } = e();
	u(() => {
		if (t?.marker) return r([t.marker.longitude, t.marker.latitude]), () => {
			r(void 0);
		};
	}, [
		t?.marker?.longitude,
		t?.marker?.latitude,
		r
	]);
	let i = d(() => {
		switch (n?.name) {
			case "maptiler": return C;
			case "google": return w;
			case "mapbox": return T;
			case "testing": return ee;
			default: return null;
		}
	}, [n]);
	return i ? /* @__PURE__ */ m(c, {
		fallback: null,
		children: /* @__PURE__ */ m(i, { ...t })
	}) : null;
}
//#endregion
//#region ../../node_modules/kdbush/index.js
var D = [
	Int8Array,
	Uint8Array,
	Uint8ClampedArray,
	Int16Array,
	Uint16Array,
	Int32Array,
	Uint32Array,
	Float32Array,
	Float64Array
], O = 1, k = 8, A = class e {
	static from(t) {
		if (!(t instanceof ArrayBuffer)) throw Error("Data must be an instance of ArrayBuffer.");
		let [n, r] = new Uint8Array(t, 0, 2);
		if (n !== 219) throw Error("Data does not appear to be in a KDBush format.");
		let i = r >> 4;
		if (i !== O) throw Error(`Got v${i} data when expected v${O}.`);
		let a = D[r & 15];
		if (!a) throw Error("Unrecognized array type.");
		let [o] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
		return new e(s, o, a, t);
	}
	constructor(e, t = 64, n = Float64Array, r) {
		if (isNaN(e) || e < 0) throw Error(`Unpexpected numItems value: ${e}.`);
		this.numItems = +e, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = n, this.IndexArrayType = e < 65536 ? Uint16Array : Uint32Array;
		let i = D.indexOf(this.ArrayType), a = e * 2 * this.ArrayType.BYTES_PER_ELEMENT, o = e * this.IndexArrayType.BYTES_PER_ELEMENT, s = (8 - o % 8) % 8;
		if (i < 0) throw Error(`Unexpected typed array class: ${n}.`);
		r && r instanceof ArrayBuffer ? (this.data = r, this.ids = new this.IndexArrayType(this.data, k, e), this.coords = new this.ArrayType(this.data, k + o + s, e * 2), this._pos = e * 2, this._finished = !0) : (this.data = new ArrayBuffer(k + a + o + s), this.ids = new this.IndexArrayType(this.data, k, e), this.coords = new this.ArrayType(this.data, k + o + s, e * 2), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, (O << 4) + i]), new Uint16Array(this.data, 2, 1)[0] = t, new Uint32Array(this.data, 4, 1)[0] = e);
	}
	add(e, t) {
		let n = this._pos >> 1;
		return this.ids[n] = n, this.coords[this._pos++] = e, this.coords[this._pos++] = t, n;
	}
	finish() {
		let e = this._pos >> 1;
		if (e !== this.numItems) throw Error(`Added ${e} items when expected ${this.numItems}.`);
		return j(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
	}
	range(e, t, n, r) {
		if (!this._finished) throw Error("Data not yet indexed - call index.finish().");
		let { ids: i, coords: a, nodeSize: o } = this, s = [
			0,
			i.length - 1,
			0
		], c = [];
		for (; s.length;) {
			let l = s.pop() || 0, u = s.pop() || 0, d = s.pop() || 0;
			if (u - d <= o) {
				for (let o = d; o <= u; o++) {
					let s = a[2 * o], l = a[2 * o + 1];
					s >= e && s <= n && l >= t && l <= r && c.push(i[o]);
				}
				continue;
			}
			let f = d + u >> 1, p = a[2 * f], m = a[2 * f + 1];
			p >= e && p <= n && m >= t && m <= r && c.push(i[f]), (l === 0 ? e <= p : t <= m) && (s.push(d), s.push(f - 1), s.push(1 - l)), (l === 0 ? n >= p : r >= m) && (s.push(f + 1), s.push(u), s.push(1 - l));
		}
		return c;
	}
	within(e, t, n) {
		if (!this._finished) throw Error("Data not yet indexed - call index.finish().");
		let { ids: r, coords: i, nodeSize: a } = this, o = [
			0,
			r.length - 1,
			0
		], s = [], c = n * n;
		for (; o.length;) {
			let l = o.pop() || 0, u = o.pop() || 0, d = o.pop() || 0;
			if (u - d <= a) {
				for (let n = d; n <= u; n++) F(i[2 * n], i[2 * n + 1], e, t) <= c && s.push(r[n]);
				continue;
			}
			let f = d + u >> 1, p = i[2 * f], m = i[2 * f + 1];
			F(p, m, e, t) <= c && s.push(r[f]), (l === 0 ? e - n <= p : t - n <= m) && (o.push(d), o.push(f - 1), o.push(1 - l)), (l === 0 ? e + n >= p : t + n >= m) && (o.push(f + 1), o.push(u), o.push(1 - l));
		}
		return s;
	}
};
function j(e, t, n, r, i, a) {
	if (i - r <= n) return;
	let o = r + i >> 1;
	M(e, t, o, r, i, a), j(e, t, n, r, o - 1, 1 - a), j(e, t, n, o + 1, i, 1 - a);
}
function M(e, t, n, r, i, a) {
	for (; i > r;) {
		if (i - r > 600) {
			let o = i - r + 1, s = n - r + 1, c = Math.log(o), l = .5 * Math.exp(2 * c / 3), u = .5 * Math.sqrt(c * l * (o - l) / o) * (s - o / 2 < 0 ? -1 : 1);
			M(e, t, n, Math.max(r, Math.floor(n - s * l / o + u)), Math.min(i, Math.floor(n + (o - s) * l / o + u)), a);
		}
		let o = t[2 * n + a], s = r, c = i;
		for (N(e, t, r, n), t[2 * i + a] > o && N(e, t, r, i); s < c;) {
			for (N(e, t, s, c), s++, c--; t[2 * s + a] < o;) s++;
			for (; t[2 * c + a] > o;) c--;
		}
		t[2 * r + a] === o ? N(e, t, r, c) : (c++, N(e, t, c, i)), c <= n && (r = c + 1), n <= c && (i = c - 1);
	}
}
function N(e, t, n, r) {
	P(e, n, r), P(t, 2 * n, 2 * r), P(t, 2 * n + 1, 2 * r + 1);
}
function P(e, t, n) {
	let r = e[t];
	e[t] = e[n], e[n] = r;
}
function F(e, t, n, r) {
	let i = e - n, a = t - r;
	return i * i + a * a;
}
//#endregion
//#region ../../node_modules/supercluster/index.js
var I = {
	minZoom: 0,
	maxZoom: 16,
	minPoints: 2,
	radius: 40,
	extent: 512,
	nodeSize: 64,
	log: !1,
	generateId: !1,
	reduce: null,
	map: (e) => e
}, L = Math.fround || ((e) => ((t) => (e[0] = +t, e[0])))(new Float32Array(1)), R = 2, z = 3, B = 4, V = 5, H = 6, U = class {
	constructor(e) {
		this.options = Object.assign(Object.create(I), e), this.trees = Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
	}
	load(e) {
		let { log: t, minZoom: n, maxZoom: r } = this.options;
		t && console.time("total time");
		let i = `prepare ${e.length} points`;
		t && console.time(i), this.points = e;
		let a = [];
		for (let t = 0; t < e.length; t++) {
			let n = e[t];
			if (!n.geometry) continue;
			let [r, i] = n.geometry.coordinates, o = L(K(r)), s = L(q(i));
			a.push(o, s, Infinity, t, -1, 1), this.options.reduce && a.push(0);
		}
		let o = this.trees[r + 1] = this._createTree(a);
		t && console.timeEnd(i);
		for (let e = r; e >= n; e--) {
			let n = +Date.now();
			o = this.trees[e] = this._createTree(this._cluster(o, e)), t && console.log("z%d: %d clusters in %dms", e, o.numItems, +Date.now() - n);
		}
		return t && console.timeEnd("total time"), this;
	}
	getClusters(e, t) {
		let n = ((e[0] + 180) % 360 + 360) % 360 - 180, r = Math.max(-90, Math.min(90, e[1])), i = e[2] === 180 ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180, a = Math.max(-90, Math.min(90, e[3]));
		if (e[2] - e[0] >= 360) n = -180, i = 180;
		else if (n > i) {
			let e = this.getClusters([
				n,
				r,
				180,
				a
			], t), o = this.getClusters([
				-180,
				r,
				i,
				a
			], t);
			return e.concat(o);
		}
		let o = this.trees[this._limitZoom(t)], s = o.range(K(n), q(a), K(i), q(r)), c = o.data, l = [];
		for (let e of s) {
			let t = this.stride * e;
			l.push(c[t + V] > 1 ? W(c, t, this.clusterProps) : this.points[c[t + z]]);
		}
		return l;
	}
	getChildren(e) {
		let t = this._getOriginId(e), n = this._getOriginZoom(e), r = "No cluster with the specified id.", i = this.trees[n];
		if (!i) throw Error(r);
		let a = i.data;
		if (t * this.stride >= a.length) throw Error(r);
		let o = this.options.radius / (this.options.extent * 2 ** (n - 1)), s = a[t * this.stride], c = a[t * this.stride + 1], l = i.within(s, c, o), u = [];
		for (let t of l) {
			let n = t * this.stride;
			a[n + B] === e && u.push(a[n + V] > 1 ? W(a, n, this.clusterProps) : this.points[a[n + z]]);
		}
		if (u.length === 0) throw Error(r);
		return u;
	}
	getLeaves(e, t, n) {
		t ||= 10, n ||= 0;
		let r = [];
		return this._appendLeaves(r, e, t, n, 0), r;
	}
	getTile(e, t, n) {
		let r = this.trees[this._limitZoom(e)], i = 2 ** e, { extent: a, radius: o } = this.options, s = o / a, c = (n - s) / i, l = (n + 1 + s) / i, u = { features: [] };
		return this._addTileFeatures(r.range((t - s) / i, c, (t + 1 + s) / i, l), r.data, t, n, i, u), t === 0 && this._addTileFeatures(r.range(1 - s / i, c, 1, l), r.data, i, n, i, u), t === i - 1 && this._addTileFeatures(r.range(0, c, s / i, l), r.data, -1, n, i, u), u.features.length ? u : null;
	}
	getClusterExpansionZoom(e) {
		let t = this._getOriginZoom(e) - 1;
		for (; t <= this.options.maxZoom;) {
			let n = this.getChildren(e);
			if (t++, n.length !== 1) break;
			e = n[0].properties.cluster_id;
		}
		return t;
	}
	_appendLeaves(e, t, n, r, i) {
		let a = this.getChildren(t);
		for (let t of a) {
			let a = t.properties;
			if (a && a.cluster ? i + a.point_count <= r ? i += a.point_count : i = this._appendLeaves(e, a.cluster_id, n, r, i) : i < r ? i++ : e.push(t), e.length === n) break;
		}
		return i;
	}
	_createTree(e) {
		let t = new A(e.length / this.stride | 0, this.options.nodeSize, Float32Array);
		for (let n = 0; n < e.length; n += this.stride) t.add(e[n], e[n + 1]);
		return t.finish(), t.data = e, t;
	}
	_addTileFeatures(e, t, n, r, i, a) {
		for (let o of e) {
			let e = o * this.stride, s = t[e + V] > 1, c, l, u;
			if (s) c = G(t, e, this.clusterProps), l = t[e], u = t[e + 1];
			else {
				let n = this.points[t[e + z]];
				c = n.properties;
				let [r, i] = n.geometry.coordinates;
				l = K(r), u = q(i);
			}
			let d = {
				type: 1,
				geometry: [[Math.round(this.options.extent * (l * i - n)), Math.round(this.options.extent * (u * i - r))]],
				tags: c
			}, f;
			f = s || this.options.generateId ? t[e + z] : this.points[t[e + z]].id, f !== void 0 && (d.id = f), a.features.push(d);
		}
	}
	_limitZoom(e) {
		return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
	}
	_cluster(e, t) {
		let { radius: n, extent: r, reduce: i, minPoints: a } = this.options, o = n / (r * 2 ** t), s = e.data, c = [], l = this.stride;
		for (let n = 0; n < s.length; n += l) {
			if (s[n + R] <= t) continue;
			s[n + R] = t;
			let r = s[n], u = s[n + 1], d = e.within(s[n], s[n + 1], o), f = s[n + V], p = f;
			for (let e of d) {
				let n = e * l;
				s[n + R] > t && (p += s[n + V]);
			}
			if (p > f && p >= a) {
				let e = r * f, a = u * f, o, m = -1, h = ((n / l | 0) << 5) + (t + 1) + this.points.length;
				for (let r of d) {
					let c = r * l;
					if (s[c + R] <= t) continue;
					s[c + R] = t;
					let u = s[c + V];
					e += s[c] * u, a += s[c + 1] * u, s[c + B] = h, i && (o || (o = this._map(s, n, !0), m = this.clusterProps.length, this.clusterProps.push(o)), i(o, this._map(s, c)));
				}
				s[n + B] = h, c.push(e / p, a / p, Infinity, h, -1, p), i && c.push(m);
			} else {
				for (let e = 0; e < l; e++) c.push(s[n + e]);
				if (p > 1) for (let e of d) {
					let n = e * l;
					if (!(s[n + R] <= t)) {
						s[n + R] = t;
						for (let e = 0; e < l; e++) c.push(s[n + e]);
					}
				}
			}
		}
		return c;
	}
	_getOriginId(e) {
		return e - this.points.length >> 5;
	}
	_getOriginZoom(e) {
		return (e - this.points.length) % 32;
	}
	_map(e, t, n) {
		if (e[t + V] > 1) {
			let r = this.clusterProps[e[t + H]];
			return n ? Object.assign({}, r) : r;
		}
		let r = this.points[e[t + z]].properties, i = this.options.map(r);
		return n && i === r ? Object.assign({}, i) : i;
	}
};
function W(e, t, n) {
	return {
		type: "Feature",
		id: e[t + z],
		properties: G(e, t, n),
		geometry: {
			type: "Point",
			coordinates: [J(e[t]), Y(e[t + 1])]
		}
	};
}
function G(e, t, n) {
	let r = e[t + V], i = r >= 1e4 ? `${Math.round(r / 1e3)}k` : r >= 1e3 ? `${Math.round(r / 100) / 10}k` : r, a = e[t + H], o = a === -1 ? {} : Object.assign({}, n[a]);
	return Object.assign(o, {
		cluster: !0,
		cluster_id: e[t + z],
		point_count: r,
		point_count_abbreviated: i
	});
}
function K(e) {
	return e / 360 + .5;
}
function q(e) {
	let t = Math.sin(e * Math.PI / 180), n = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
	return n < 0 ? 0 : n > 1 ? 1 : n;
}
function J(e) {
	return (e - .5) * 360;
}
function Y(e) {
	let t = (180 - e * 360) * Math.PI / 180;
	return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
//#endregion
//#region ../../node_modules/dequal/dist/index.mjs
var X = Object.prototype.hasOwnProperty;
function Z(e, t, n) {
	for (n of e.keys()) if (Q(n, t)) return n;
}
function Q(e, t) {
	var n, r, i;
	if (e === t) return !0;
	if (e && t && (n = e.constructor) === t.constructor) {
		if (n === Date) return e.getTime() === t.getTime();
		if (n === RegExp) return e.toString() === t.toString();
		if (n === Array) {
			if ((r = e.length) === t.length) for (; r-- && Q(e[r], t[r]););
			return r === -1;
		}
		if (n === Set) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r, i && typeof i == "object" && (i = Z(t, i), !i) || !t.has(i)) return !1;
			return !0;
		}
		if (n === Map) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r[0], i && typeof i == "object" && (i = Z(t, i), !i) || !Q(r[1], t.get(i))) return !1;
			return !0;
		}
		if (n === ArrayBuffer) e = new Uint8Array(e), t = new Uint8Array(t);
		else if (n === DataView) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e.getInt8(r) === t.getInt8(r););
			return r === -1;
		}
		if (ArrayBuffer.isView(e)) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e[r] === t[r];);
			return r === -1;
		}
		if (!n || typeof e == "object") {
			for (n in r = 0, e) if (X.call(e, n) && ++r && !X.call(t, n) || !(n in t) || !Q(e[n], t[n])) return !1;
			return Object.keys(t).length === r;
		}
	}
	return e !== e && t !== t;
}
//#endregion
//#region node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js
function te(e) {
	var t = s.useRef(e), n = s.useRef(0);
	return Q(e, t.current) || (t.current = e, n.current += 1), s.useMemo(function() {
		return t.current;
	}, [n.current]);
}
function ne(e, t) {
	return s.useEffect(e, te(t));
}
//#endregion
//#region node_modules/use-supercluster/dist/use-supercluster.esm.js
var re = function(e) {
	var t = e.points, n = e.bounds, r = e.zoom, i = e.options, a = e.disableRefresh, o = f(), s = f(), c = p([]), l = c[0], u = c[1], d = Math.round(r);
	return ne(function() {
		a !== !0 && ((!o.current || !Q(s.current, t) || !Q(o.current.options, i)) && (o.current = new U(i), o.current.load(t)), n && u(o.current.getClusters(n, d)), s.current = t);
	}, [
		t,
		n,
		d,
		i,
		a
	]), {
		clusters: l,
		supercluster: o.current
	};
}, ie = l(() => import("./Maptiler-DqeshLom.js")), ae = l(() => import("./Google-CXGCn-oJ.js")), oe = l(() => import("./Mapbox-DDJ1gHRb.js")), se = l(() => import("./Testing--n5Ro0Ek.js"));
function ce({ isLoading: t, markers: r, onClick: i, ...a }) {
	let { mapProvider: s, activeMarker: l, zoom: p, setMarkerPoints: h, setClusterPoints: g } = e();
	u(() => {
		t || h((r || []).map((e) => [e.longitude, e.latitude]));
	}, [r, h]);
	let { clusters: _, supercluster: v } = re(d(() => ({
		points: r.map((e) => o([e.longitude, e.latitude], e)),
		bounds: n,
		zoom: p,
		options: {
			radius: s.name === "google" && p > 10 ? 60 : 30,
			minZoom: 10,
			maxZoom: 22
		}
	}), [
		r,
		s,
		p
	])), y = f("");
	u(() => {
		let e = JSON.stringify(_.map((e) => ({
			coords: e.geometry.coordinates,
			props: e.properties
		})));
		e !== y.current && (g(_), y.current = e);
	}, [_, g]);
	let b = (e) => {
		if (!("properties" in e)) throw Error("Cluster does not have properties");
		if (e.properties?.cluster && typeof e.properties?.cluster_id == "number") {
			i?.({
				id: `${e.properties.cluster_id}`,
				latitude: e.geometry.coordinates[1],
				longitude: e.geometry.coordinates[0],
				markers: v?.getLeaves(e.properties.cluster_id)?.map((e) => e.properties) ?? []
			});
			return;
		}
		i?.({
			id: e.properties.id,
			latitude: e.properties.latitude,
			longitude: e.properties.longitude,
			markers: [e.properties]
		});
	}, x = (e) => {
		if (!v || !l) return !1;
		if (l.id === `${e}`) return !0;
		try {
			return v.getLeaves(e)?.find((e) => e.properties.id === l.id) !== void 0;
		} catch {
			return !1;
		}
	}, S = d(() => {
		switch (s?.name) {
			case "maptiler": return ie;
			case "google": return ae;
			case "mapbox": return oe;
			case "testing": return se;
			default: return null;
		}
	}, [s]);
	return S ? /* @__PURE__ */ m(c, {
		fallback: null,
		children: /* @__PURE__ */ m(S, {
			clusters: _,
			onClick: b,
			doesSuperclusterContainActiveMarker: x,
			...a
		})
	}) : null;
}
//#endregion
//#region src/components/Map/Root/Popup/index.tsx
var le = l(() => import("./Maptiler-BtYYeJoo.js")), $ = l(() => import("./Google-DScXSvYv.js")), ue = l(() => import("./Mapbox-B7oionsm.js")), de = l(() => import("./Testing-CoRLhmNT.js"));
function fe({ children: t, anchor: n = "bottom", ...r }) {
	let { mapProvider: i } = e(), a = d(() => {
		switch (i?.name) {
			case "maptiler": return le;
			case "google": return $;
			case "mapbox": return ue;
			case "testing": return de;
			default: return null;
		}
	}, [i]);
	return a ? /* @__PURE__ */ m(c, {
		fallback: null,
		children: /* @__PURE__ */ m(a, {
			...r,
			anchor: n,
			children: t
		})
	}) : null;
}
//#endregion
//#region src/components/Map/Root/Layers/index.tsx
var pe = l(() => import("./Maptiler-BQliPE7n.js")), me = l(() => import("./Google-qvGtRAuh.js")), he = l(() => import("./Mapbox-vp91lH9I.js")), ge = l(() => import("./Testing-DGUeGxdc.js"));
function _e(t) {
	let { mapProvider: n } = e(), r = d(() => {
		switch (n?.name) {
			case "maptiler": return pe;
			case "google": return me;
			case "mapbox": return he;
			case "testing": return ge;
			default: return null;
		}
	}, [n]);
	return r ? /* @__PURE__ */ m(c, {
		fallback: null,
		children: /* @__PURE__ */ m(r, { ...t })
	}) : null;
}
//#endregion
//#region src/components/Map/Root/index.tsx
var ve = /* @__PURE__ */ g({
	BaseMap: () => S,
	CenterPin: () => E,
	Layers: () => _e,
	Markers: () => ce,
	Popup: () => fe,
	Root: () => ye
});
function ye(e) {
	let [n, r] = p(), [o, s] = p([]), [c, l] = p([]), [u, d] = p(e.zoom || i.zoom);
	return /* @__PURE__ */ m(t.Provider, {
		value: {
			...e,
			locale: e.locale || "en",
			mapPadding: e.mapPadding || a,
			locationBoundary: e.locationBoundary,
			centerPinMarkerPoints: n,
			setCenterPinMarkerPoints: r,
			markerPoints: o,
			setMarkerPoints: s,
			clusterPoints: c,
			setClusterPoints: l,
			zoom: u,
			setZoom: d
		},
		children: e.children
	});
}
//#endregion
export { ve as LocalLogicMap };
